export interface UserBase {
  // I don't know how a user exists without an email, but we get NPE errors here occasionally
  email?: string;
  screen_name: string;
  position: string;
  is_admin: boolean;
  can_download?: boolean;
}

export interface IUser extends UserBase {
  id: string;
  is_pseudonymized?: boolean;
  is_forgotten?: boolean;
  terms_agreed_at?: string | null;
  is_citrine_user?: boolean;
  api_keys?: number;
}

export interface INewUser extends UserBase {
  use_sso?: boolean;
  number?: string;
}

export type CognitoStatus =
  | "UNCONFIRMED"
  | "EXTERNAL_PROVIDER"
  | "CONFIRMED"
  | "ARCHIVED"
  | "COMPROMISED"
  | "UNKNOWN"
  | "RESET_REQUIRED"
  | "FORCE_CHANGE_PASSWORD";

export type MfaMethod = "SMS_MFA" | "SOFTWARE_TOKEN_MFA";

export interface CognitoStatusResponse {
  readonly enabled_mfa_methods: MfaMethod[];
  readonly phone_number?: string;
  readonly preferred_mfa_method: MfaMethod | null;
  readonly status: CognitoStatus;
}

export interface Terms {
  terms_agreed: boolean;
}

export function isCitrineUser({ email }: { email?: string }) {
  return email?.toLowerCase().endsWith("@citrine.io");
}
